import { pascalCase as pascalCase$1, pascalCaseTransformMerge } from './../../_node_modules/pascal-case/dist.es2015/index.js';
const pascalCase = (...input) => {
  return pascalCase$1(input.filter(Boolean).join(" "), {
    transform: pascalCaseTransformMerge
  });
};
export {
  pascalCase
};
//# sourceMappingURL=pascalCase.js.map
